import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reject-line-modal',
  templateUrl: './reject-line-modal.component.html',
  styleUrls: ['./reject-line-modal.component.css'],
})
export class RejectLineModalComponent implements OnInit {
  @Input() rejectReasons: any[];
  formData: any = {};

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.formData = {};

    if (this.rejectReasons.length != 0) this.formData.Reason = this.rejectReasons[0].ReasonCode;
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }

  rejectClicked() {
    this.activeModal.close({ Action: 'Reject', Reason: this.formData });
  }
}
